import { Box, Divider, Grid } from "@mui/material";
import _ from "lodash";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { MultipleSelectField, TextInputField } from "../../../components/FormField";
import { useGetRoles } from "../hooks";
import { generateOptions } from "../../../utils/options";
import { useMerchantStore } from "../../../stores/merchant";
import PhoneInputField from "./PhoneInputField";

/** Assigns a sole merchant automatically and retains the selector for multiple merchants. */
const UserForm = () => {
  const { register, setValue } = useFormContext();
  const { merchants } = useMerchantStore();
  const { data: roles } = useGetRoles();
  const singleMerchantId = merchants.length === 1 ? merchants[0]._id : null;

  useEffect(() => {
    if (singleMerchantId) {
      setValue("merchants", [singleMerchantId]);
    }
  }, [singleMerchantId, setValue]);

  const rolesOptions = generateOptions(roles, false).map((option) => ({
    ...option,
    label: _.startCase(_.toLower(option.label)),
  }));
  const merchantsOptions = generateOptions(merchants, false);

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextInputField label="Name" name="name" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextInputField label="Surname" name="surname" />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextInputField label="Email" name="email" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <PhoneInputField />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <MultipleSelectField
            name="roles"
            label="Roles"
            options={rolesOptions}
            placeholder="Select roles"
            menuPosition="fixed"
          />
        </Grid>
        {singleMerchantId ? (
          <input type="hidden" {...register("merchants.0")} value={singleMerchantId} />
        ) : (
          <Grid item xs={12} sm={6}>
            <MultipleSelectField
              menuPosition="fixed"
              name="merchants"
              label="Merchants"
              options={merchantsOptions}
              placeholder="Select merchants"
            />
          </Grid>
        )}
      </Grid>
      <Divider />
    </Box>
  );
};

export default UserForm;
